import { JSX } from "react";

interface SelectItemProps {
    label: string;
    options: Array<string>;
    optionLabel: string;
    fieldName: string;
    fieldErrors: Array<string>;
    onChange: (event: React.ChangeEvent<HTMLSelectElement>) => void;
}

export default function SelectItem ({label, options, onChange, optionLabel, fieldName, fieldErrors}: SelectItemProps): JSX.Element {

    return (
        <div className={"form-group mb-3"}>
            <label className={"form-label text-cemter"}><strong>{ label }:</strong></label>
            <select className={"form-control"} onChange={onChange} name={fieldName} required={true}>
                <option key={1} value={""} className={"text-center"}>{
                    options.length > 0 ? optionLabel : "Brak wolnych terminów"
                }</option>
                {
                    options.length > 0 && (
                        options.map(
                            (value: string, index: number) => <option key={index} value={value}
                                                                      className={"text-center"}
                            >
                                {value}
                            </option>
                        )
                    )
                }
            </select>
            {
                fieldErrors.length > 0 && (
                    <div className={"p-2"}>
                        {
                            fieldErrors.map(
                                (
                                    error: string,
                                    index: number
                                ) => <div key={index} className={"text-danger"}>{error}</div>
                            )
                        }
                    </div>
                )
            }
        </div>
    );
}